import { crudFor } from "./dataClient";
import { seedSponsors } from "@/data/seed/sponsors";

// NOTE: the underlying Supabase table is named `donors` to avoid
// a clash with a pre-existing `sponsors` table in the same project.
// All UI labels still read "Sponsors".
export const sponsorsCrud = crudFor("donors", seedSponsors);

export const sponsorsService = {
  async listSponsors(category) {
    const rows = await sponsorsCrud.list((q) => q.eq("is_published", true).order("sort_order"));
    return rows
      .filter(
        (s) =>
          s.is_published !== false && (!category || category === "All" || s.category === category)
      )
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  },

  async listFeatured(limit = 4) {
    const all = await this.listSponsors();
    return all.filter((s) => s.is_featured).slice(0, limit);
  },

  async listCategories() {
    const all = await this.listSponsors();
    return ["All", ...Array.from(new Set(all.map((s) => s.category).filter(Boolean)))];
  },
};
